import styled from "styled-components";

export const Spacer = styled.div<{
  direction?: "bottom" | "top" | "left" | "right";
  size: number;
}>`
    margin-${({ direction }) => direction ?? "bottom"}: ${({ size }) => size}px;
`;
